import {useIntl} from 'react-intl';
import useAlerts from './use-alerts';

// The report endpoints answer validation errors as {"message": "..."} in pt-BR. Any
// other body (an older server still answers with a raw Java stack trace as plain text)
// falls back to the generic copy instead of being shown to the user.
const getBackendMessage = (error) => {
    const message = error && error.data && error.data.message;
    return typeof message === 'string' && message.trim() ? message : null;
};

const useReportError = () => {
    const intl = useIntl();
    const {toast} = useAlerts();

    return (error) => {
        toast.error(
            getBackendMessage(error) || intl.formatMessage({id: 'reportLoadError'}),
        );
    };
};

export default useReportError;
